<template>
    <div>
        <h4 class="mb-4">Certificate</h4>
        <div style="height: 300px;" class="light_grey_holder w-full">
        </div>
        <vs-button class="block mx-auto my-4">Select Certificate Template</vs-button>

        <h4 class="mb-4">Share Options</h4>
        <div>
            <vs-radio
                v-model="share"
                vs-value="manual"
                class="mx-2"
            >
                Manual Share
            </vs-radio>
            <vs-radio
                v-model="share"
                vs-value="auto"
                class="mx-2"
            >
                Share after class end date
            </vs-radio>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      share: 'manual'
    }
  }
}
</script>